import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Exam } from '../exam.js';

export const updateGradingScaleMutation = registerMutation({
  operationName: 'updateGradingScaleMutation',
  type: () => Boolean,
  params: [
    { name: 'examId', type: () => String },
    { name: 'gradingScaleJson', type: () => String },
  ],
  resolve: (examId: string, gradingScaleJson: string) => async () => {
    // Validate that it's valid JSON with the expected shape
    const parsed = JSON.parse(gradingScaleJson);
    if (!parsed?.type || !Array.isArray(parsed?.borders)) {
      throw new Error('Ungültiges Notenmaßstab-Format.');
    }

    const examCollection = await getCollection(Exam);
    const result = await examCollection.updateOne({ _id: examId }, { $set: { gradingScaleJson } });

    if (result.matchedCount === 0) {
      throw new Error(`Klausur mit ID ${examId} nicht gefunden.`);
    }

    return true;
  },
});
